import { compose, graphql } from "react-apollo";

import { GET_AUTHENTICATION_ACTIVITY } from "../../graphql/queries";
import { GET_DATE_RANGE, GET_TABLE_PARAMS } from "../../cacheql/queries";
import { SET_TABLE_PARAMS } from "../../cacheql/mutations";
import { getCardParams, getCommunityIds } from "../../utils/helpers";
import UsageTable from "./usage-table";

export default compose(
  graphql(SET_TABLE_PARAMS, { name: "setTableParams" }),
  graphql(GET_TABLE_PARAMS, { name: "getTableParams" }),
  graphql(GET_DATE_RANGE, { name: "selectedDateRange" }),
  graphql(GET_AUTHENTICATION_ACTIVITY, {
    options: ({ getTableParams: { tableParams }, ...props }) => {
      const params = getCardParams("Usage Report", tableParams);

      return {
        variables: {
          filter: {
            csm_id: props.selectedSingleUserId.id,
            activity_start_date: props.selectedDateRange.selectedDateRange.startDate,
            activity_end_date: props.selectedDateRange.selectedDateRange.endDate,
            ...(params && params.filter)
          },
          pageNum: (params && params.pageNum) || 0,
          limit: (params && params.limit) || 10,
        },
        fetchPolicy: "no-cache"
      };
    }
  })
)(UsageTable);
